<template>
  <v-container fluid>
    <v-card-title class="card-title pa-3" style="border-bottom: 1px solid #C9C9C9;">
      <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('tokenSummationReportManagement') }}</h1>
    </v-card-title>

    <div class="form-container">
      <v-row>
        <v-col cols="12" sm="6" md="6" class="custom">
          <v-img :src="images.questionset" width="14" height="14" class="customimg" />
          <h1 style="font-weight: 600; font-size: 16px;">{{ $t('modelFilters') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="5" lg="4">
          <v-card-text class="pa-0">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Start Date" class="text-sm font-medium text-gray-700">
                {{ $t('modelIdCol') }}
              </label>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                    style="cursor: pointer; margin-left: 4px;" />
                </template>
                <span>{{ $t('searchModelById') }}</span>
              </v-tooltip>
            </div>
            <v-text-field id="id-field-search-reporttokensum" :placeholder="$t('enterModelID')" v-model="modelIDForQuery"
              @keypress="isNumberpositive($event)" variant="outlined" density="compact" color="primary" clearable>
              <template #append-inner>
                <v-tooltip location="top" max-width="200">
                  <span>{{ $t('enterModelIdToFilter') }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-card-text>
        </v-col>
        <v-col cols="12" sm="6" md="5" lg="4">
          <v-card-text class="pa-0">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Start Date" class="text-sm font-medium text-gray-700">
                {{ $t('modelNameCol') }}
              </label>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                    style="cursor: pointer; margin-left: 4px;" />
                </template>
                <span>{{ $t('searchModelByName') }}</span>
              </v-tooltip>
            </div>
            <v-text-field id="modelname-field-search-reporttokensum" :placeholder="$t('enterModelName')"
              v-model="modelNameForQuery" type="text" variant="outlined" density="compact" color="primary" clearable>
              <template #append-inner>
                <v-tooltip location="top" max-width="200">
                  <span>{{ $t('enterModelNameToFilter') }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-card-text>
        </v-col>
        <!-- Replace the current reportdata-stats section (lines 67-76) with this: -->
        <v-col cols="12" md="12" lg="3" class="d-flex justify-space-between ml-auto pl-0">
          <v-divider vertical class="reportdata-filter-divider d-xl-flex"></v-divider>
          <div class="reportdata-stats">
            <div class="reportdata-stats-header">
              <v-icon size="20" class="reportdata-stats-icon">mdi-chart-box-outline</v-icon>
              <span class="reportdata-stats-title">{{ $t('statistics') }}</span>
            </div>
            <v-chip size="large" class="summary-chip" variant="flat">
              <span class="reportdata-stats-count">{{ totalRows }} {{ $t('models') }}</span>
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="form-container">
      <v-row>
        <v-col cols="12" sm="6" md="6" class="custom">
          <v-img :src="images.arrowImg" width="14" height="14" class="customimg" />
          <h1 style="font-weight: 600; font-size: 16px;">{{ $t('dateRange') }}</h1>
        </v-col>
      </v-row>
      <v-row class="items-center mt-2">
        <!-- Start Date -->
        <v-col cols="12" sm="6" md="5" lg="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="Start Date" class="text-sm font-medium text-gray-700">
              {{ $t('startDate') }}
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                  style="cursor: pointer; margin-left: 4px;" />
              </template>
              <span>{{ $t('selectStartDateFilter') }}</span>
            </v-tooltip>
          </div>
          <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition"
            location="bottom" min-width="auto">
            <template #activator="{ props }">
              <v-text-field :model-value="formatDateDisplay(startDate)" :placeholder="$t('Select date')" readonly variant="outlined" v-bind="props"
                density="compact" class="reportdata-field-date mt-1" clearable @click:clear="startDate = null"
                hide-details>
                <template #prepend-inner>
                  <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="startDate" :key="`start-${startPickerYear}-${startPickerMonth}`"
              :year="startPickerYear" :month="startPickerMonth" @update:year="startPickerYear = $event"
              @update:month="startPickerMonth = $event" :max="new Date().toISOString().substr(0, 10)"
              @update:model-value="
                (val) => {
                  startDate = formatDate(val);
                  startDateFlag = false;
                }
              " show-adjacent-months class="date-picker">
              <template #header>
                <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                  <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(startPickerYear, startPickerMonth,
                    startDate) }}</div>
                  <v-select v-model="startPickerYear" :items="years" density="compact" variant="plain" hide-details
                    class="month-year-select" style="width: 100px;"></v-select>
                </div>
              </template>
            </v-date-picker>
          </v-menu>
        </v-col>

        <div class="date-divider d-none d-lg-flex">-</div>

        <!-- End Date -->
        <v-col cols="12" sm="6" md="5" lg="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="End Date" class="text-sm font-medium text-gray-700">
              {{ $t('endDate') }}
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                  style="cursor: pointer; margin-left: 4px;" />
              </template>
              <span>{{ $t('selectEndDateFilter') }}</span>
            </v-tooltip>
          </div>
          <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom"
            min-width="auto">
            <template #activator="{ props }">
              <v-text-field :model-value="formatDateDisplay(endDate)" :placeholder="$t('Select date')" readonly variant="outlined" v-bind="props"
                density="compact" class="reportdata-field-date mt-1" clearable @click:clear="endDate = null" hide-details>
                <template #prepend-inner>
                  <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="endDate" :key="`end-${endPickerYear}-${endPickerMonth}`" :year="endPickerYear"
              :month="endPickerMonth" @update:year="endPickerYear = $event" @update:month="endPickerMonth = $event"
              :min="startDate != null ? startDate : null" @update:model-value="
                (val) => {
                  endDate = formatDate(val);
                  endDateFlag = false;
                }
              " color="#C32E0E" class="date-picker">
              <template #header>
                <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                  <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(endPickerYear, endPickerMonth,
                    endDate) }}</div>
                  <v-select v-model="endPickerYear" :items="years" density="compact" variant="plain" hide-details
                    class="month-year-select" style="max-width: 90px;"></v-select>
                </div>
              </template>
            </v-date-picker>
          </v-menu>
        </v-col>

        <!-- Search Button -->
        <v-col cols="12" md="auto" class="d-flex justify-center align-center px-0 mt-3">
          <v-tooltip location="top" max-width="200">
            <template #activator="{ props }">
              <v-btn v-bind="props" icon class="reportdata-icon-btn reportdata-icon-btn--primary mb-1" variant="flat"
                @click="Search" aria-label="Search">
                <v-icon size="22">mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('searchCurrentFilters') }}</span>
          </v-tooltip>
        </v-col>
        <!-- Quick Date Range Filters -->
        <v-col cols="12" md="12" lg="3" class="d-flex align-center justify-space-between ml-auto pl-0 pt-0">
          <v-divider vertical class="reportdata-filter-divider d-xl-flex"></v-divider>
          <div class="reportdata-quick-section">
            <div class="reportdata-quick-header">
              <span class="reportdata-quick-title">{{ $t('quickDateRange') }}</span>
            </div>
            <div class="reportdata-quick-controls">
              <v-select v-model="selectedQuickRange" :items="quickDateRanges" item-title="title" item-value="value"
                @update:model-value="onQuickRangeChange"
                variant="outlined" density="compact" class="reportdata-quick-select" hide-details :placeholder="$t('today')"
                :menu-props="{ contentClass: 'quick-range-menu' }">
                <template #prepend-inner>
                  <img src="@/assets/Icons/new_calendar_white.png" alt="calendar" width="20" height="20"
                    class="mr-1 mb-2" />
                </template>
              </v-select>
              <v-tooltip location="top" max-width="200">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon class="reportdata-icon-btn reportdata-icon-btn--reset" variant="flat"
                    @click="resetFilters" aria-label="Reset to default">
                    <v-icon size="20">mdi-sync</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('resetToDefault') }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-card-text style="padding: 0">
      <!-- Action Buttons Row -->
      <v-row class="mb-4">
        <v-col cols="12">

          <!-- Right Side - Download Button -->
          <div class="reportdata-action-group">
            <v-btn color="success" variant="flat" size="large" @click="GetForDownload()"
              class="reportdata-download-btn ml-4" prepend-icon="mdi-download">
              {{ $t('DownloadReport') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- Data Table with Modern Styling -->
      <div class="form-container">
        <div class="py-3">
            <h2 style="font-weight: 600;">{{ $t('tokenSummationData') }}</h2>
        </div>
        <v-data-table-server v-model:options="options" :items="listTotaltoken.modelDetail"
          :items-per-page="options.itemsPerPage" :headers="headers" :items-length="listTotaltoken.allRow"
          :loading="loadingTable" :footer-props="{
            'items-per-page-options': [5, 10, 25, 50, 100],
          }" density="comfortable" hover>

          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">{{ $t('noDataAvailable') }}</span>
            </div>
          </template>

          <template #item="{ item }">
            <tr class="reportdata-table-row">
              <td class="text-center">
                {{ item.number }}
              </td>
              <td class="text-center">
                {{ item.modelDisplay }}
              </td>
              <td>
                <div class="text-container">
                  <span class="reportdata-text-standard">
                    {{ item.modelName }}
                  </span>
                </div>
              </td>
              <td>
                <div class="text-container">
                  <span class="reportdata-text-standard">
                    {{ item.model }}
                  </span>
                </div>
              </td>
              <td class="text-center">
                {{ item.llmName }}
              </td>
              <td class="text-center">
                {{ item.totalPromptTokenDisplay }}
              </td>
              <td class="text-center">
                {{ item.totalCompletionTokensDisplay }}
              </td>
              <td class="text-center">
                {{ item.totalTokenDisplay }}
              </td>
              <td class="text-center">
                {{ item.totalImageGeneration }}
              </td>
              <td class="text-center">
                {{ item.totalCachedTokens }}
              </td>
              <td class="text-center">
                {{ item.totalReasoningTokens }}
              </td>
            </tr>
          </template>
            
          <template v-slot:bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>{{ $t('totalResults') }} {{ totalRows }}</div>

              <v-data-table-footer v-model:items-per-page="options.itemsPerPage" :page="options.page"
                :length="Math.ceil(totalRows / options.itemsPerPage)" />
            </div>
          </template>
        </v-data-table-server>
      </div>
    </v-card-text>

    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="showDateRequire" max-width="480" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t('actionNeeded') }}</h3>
          <button type="button" @click="showDateRequire = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p v-if="dateRequireSource !== 'download'" class="required-name-message">
            {{ $t('dateRangeRequired') }}
          </p>
          <p v-else class="required-name-message">
            {{ $t('downloadDateRequired') }}
          </p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showDateRequire = false" :id="'button-requiredname-ok'">{{ $t('ok') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import questionImg from '@/assets/Icons/modelfilter.png';
import arrowImg from '@/assets/Icons/new_arrow_range.png';
const currentDate = new Date();
export default {
  name: "ReportTokenSum",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  computed: {
    totalRows() {
      const value = Number(this.listTotaltoken?.allRow);
      return Number.isFinite(value) && value > 0 ? value : 0;
    },
    quickDateRanges() {
      return [
        { title: this.$t('today'), value: 'Today' },
        { title: this.$t('yesterday'), value: 'Yesterday' },
        { title: this.$t('last30Days'), value: 'Last 30 days' },
        { title: this.$t('thisMonth'), value: 'This month' },
      ];
    },
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          value: "number",
          sortable: false,
          width: "60px",
          minWidth: "60px",
        },
        {
          title: this.$t("modelIdCol"),
          align: "center",
          value: "modelDisplay",
          sortable: true,
          width: "80px",
          minWidth: "80px",
        },
        {
          title: this.$t("modelNameCol"),
          align: "left",
          value: "modelName",
          sortable: true,
          width: "200px",
          minWidth: "180px",
        },
        {
          title: this.$t("modelCol"),
          align: "left",
          value: "model",
          sortable: true,
          width: "160px",
          minWidth: "140px",
        },
        {
          title: this.$t("llmCol"),
          align: "left",
          value: "model",
          sortable: true,
          width: "160px",
          minWidth: "140px",
        },
        {
          title: this.$t("inputTokens"),
          align: "center",
          value: "totalPromptTokenDisplay",
          sortable: true,
          width: "120px",
          minWidth: "100px",
        },
        {
          title: this.$t("outputTokens"),
          align: "center",
          value: "totalCompletionTokensDisplay",
          sortable: true,
          width: "120px",
          minWidth: "100px",
        },
        {
          title: this.$t("totalTokens"),
          align: "center",
          value: "totalTokenDisplay",
          sortable: true,
          width: "120px",
          minWidth: "100px",
        },
        {
          title: this.$t("imageGenShort"),
          align: "center",
          value: "totalImageGeneration",
          sortable: true,
          width: "100px",
          minWidth: "90px",
        },
        {
          title: this.$t("cachedShort"),
          align: "center",
          value: "totalCachedTokens",
          sortable: true,
          width: "100px",
          minWidth: "90px",
        },
        {
          title: this.$t("reasoningShort"),
          align: "center",
          value: "totalReasoningTokens",
          sortable: true,
          width: "100px",
          minWidth: "90px",
        },
      ];
    },
  },
  data: () => ({
    showDateRequire: false,
    dateRequireSource: null,
    loadingTable: false,
    isIntialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    totalRow: 0,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    images: {
      questionset: questionImg,
      arrowImg: arrowImg,
    },
    selectedQuickRange: null,

    // Date picker state management
      startPickerYear: currentDate.getFullYear(),
      startPickerMonth: currentDate.getMonth(),
      endPickerYear: currentDate.getFullYear(),
      endPickerMonth: currentDate.getMonth(),

      years: Array.from({ length: 10 }, (_, i) => currentDate.getFullYear() - i),
    modelIDForQuery: "",
    loading: false,
    modelNameForQuery: "",
    sortBy: [],
    sortDesc: [],
    isSearch: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    listTotaltoken: {
      number: 0,
      allRow: 0,
      modelDetail: [
        {
          number: "number",
          modelName: "",
          model: "",
          modelDisplay: 0,
          totalToken: 0,
        },
      ],
    },
  }),
  watch: {
    startDateFlag(newVal) {
      if (newVal) {
        if (this.startDate) {
          const date = new Date(this.startDate);
          this.startPickerYear = date.getFullYear();
          this.startPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.startPickerYear = today.getFullYear();
          this.startPickerMonth = today.getMonth();
        }
      }
    },
    endDateFlag(newVal) {
      if (newVal) {
        if (this.endDate) {
          const date = new Date(this.endDate);
          this.endPickerYear = date.getFullYear();
          this.endPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.endPickerYear = today.getFullYear();
          this.endPickerMonth = today.getMonth();
        }
      }
    },
    options: {
      handler() {
        if (!this.isIntialized) return;
        this.fetchReport();
      },
      deep: true,
    },
  },
  mounted() {
    const date = new Date();
    this.startDate = this.convertDateToString2(date);
    this.endDate = this.convertDateToString2(date);
    this.GetDate();
    this.Search();
    this.isIntialized = true;
    this.applyQuickRange('Today', false);
  },
  methods: {
    formatNumber(value) {
      return value.toLocaleString();
    },
    isDateRangeSelected() {
      return !!(this.startDate && this.endDate);
    },
    Search() {
      if (!this.isDateRangeSelected()) {
        this.dateRequireSource = 'search';
        this.showDateRequire = true;
        this.isSearch = false;
        return;
      }

      this.isSearch = true;
      this.fetchReport();
    },
    onQuickRangeChange(range) {
      if (!range) {
        return;
      }
      this.applyQuickRange(range);
    },
    applyQuickRange(range, triggerSearch = true) {
      const todayMoment = moment().startOf('day');
      let start = todayMoment.clone();
      let end;

      switch (range) {
        case 'Yesterday':
          start = todayMoment.clone().subtract(1, 'day');
          end = start.clone();
          break;
        case 'Last 30 days':
          start = todayMoment.clone().subtract(29, 'day');
          end = todayMoment.clone();
          break;
        case 'This month':
          start = todayMoment.clone().startOf('month');
          end = todayMoment.clone();
          break;
        default:
          start = todayMoment.clone();
          end = todayMoment.clone();
          break;
      }

      this.startDate = this.formatDate(start.toDate());
      this.endDate = this.formatDate(end.toDate());
      this.selectedQuickRange = range;

      if (triggerSearch) {
        this.Search();
      }
    },
    resetFilters() {
      this.applyQuickRange('Today');
    },
    // Shared report-query builder used by fetchReport + GetForDownload; extracted to remove duplicated block
    // (SonarQube). Behavior-neutral — identical tempData.
    buildReportTokenQuery() {
      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      const tempData = {
        startDate: this.startDate,
        stopDate: this.endDate,
        page: page,
        pageResult: itemsPerPage,
        modelIDForQuery: this.modelIDForQuery,
        modelNameForQuery: this.modelNameForQuery,
        sortBy: sortField,
        sortDesc: sortOrder,
      };
      if (tempData.modelIDForQuery == "" || tempData.modelIDForQuery == null) {
        tempData.modelIDForQuery = -1;
      }
      return tempData;
    },
    fetchReport() {
      if (this.isSearch) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
      }
      this.loadingTable = true;
      const tempData = this.buildReportTokenQuery();

      this.$call.ReportTokenSum(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const listData = dataResponse?.data?.listData || [];
            this.listTotaltoken.modelDetail = Array.isArray(listData) ? listData : [];
            this.listTotaltoken.allRow = Number(dataResponse?.data?.allRow) || 0;

            if (this.listTotaltoken.modelDetail.length === 0) {
              this.listTotaltoken.allRow = 0;
            } else {
              this.listTotaltoken.modelDetail.forEach((l) => {
                l.totalPromptTokenDisplay = (l.totalPromptToken ?? 0).toLocaleString();
                l.totalCompletionTokensDisplay =
                  (l.totalCompletionTokens ?? 0).toLocaleString();
                l.totalTokenDisplay = (l.totalToken ?? 0).toLocaleString();
                l.totalImageGeneration =
                  (l.totalImageGeneration ?? 0).toLocaleString();
                l.totalCachedTokens = (l.totalCachedTokens ?? 0).toLocaleString();
                l.totalReasoningTokens =
                  (l.totalReasoningTokens ?? 0).toLocaleString();
              });
            }

            this.loadingTable = false;
            this.isSearch = false;
          }
        },
        (errorResource) => {
          this.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    async GetForDownload() {
      if (!this.isDateRangeSelected()) {
        this.dateRequireSource = 'download';
        this.showDateRequire = true;
        this.loading = false;
        return;
      }

      this.loading = true;
      const tempData = this.buildReportTokenQuery();

      await this.$call.ExportReportTokenSummation(
        tempData,
        async (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameShow = `ReportTokenSummation__${this.convertDateToString(
              new Date(),
              ""
            )}.xlsx`;
            fileLink.setAttribute("download", fileNameShow);
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }
          this.loading = false;
        },
        async (errorResource) => {
          this.loading = false;
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #AA6600;
}
.form-container {
  background: white;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin: 15px;
}

.custom {
  display: flex;
  align-items: center;
  gap: 5px;
}

.customimg {
  max-width: 15px !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #646464;
  font-weight: 700;
  font-size: 20px;
  padding-top: 10px;
}

.reportdata-filter-divider {
  height: 60px;
  align-items: center;
  border-color: #C9C9C9 !important;
  opacity: 1;
  margin-right: 10px;
}

.reportdata-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  flex: 1;
}

.reportdata-stats-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reportdata-stats-icon {
  color: #C32E0E !important;
}

.reportdata-stats-title {
  font-weight: 600;
  font-size: 14px;
  color: #C32E0E;
}

.reportdata-stats-count {
  font-size: 14px;
  font-weight: 600;
}

.reportdata-icon-btn {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  min-width: 42px;
}

.reportdata-icon-btn--primary {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
  color: #ffffff !important;
}

.reportdata-icon-btn--ghost {
  background: #ffffff !important;
  color: #171717 !important;
  border: 1px solid #d0d0d0 !important;
}

.reportdata-quick-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  padding: 8px 12px;
}

.reportdata-quick-header {
  display: flex;
  align-items: center;
}

.reportdata-quick-title {
  font-weight: 600;
  font-size: 14px;
  color: #2C2C2C;
}

.reportdata-quick-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reportdata-quick-select {
  flex: 1;
  min-width: 180px;
}

.reportdata-quick-select :deep(.v-field__outline) {
  border-color: #D0D0D0;
}

.reportdata-quick-select :deep(.v-field__input) {
  padding-left: 4px;
  min-height: 40px;
}

.reportdata-quick-select :deep(.v-select__selection-text) {
  font-weight: 500;
  color: #2C2C2C;
  font-size: 14px;
}

.reportdata-quick-select :deep(.v-field__prepend-inner) {
  padding-top: 8px;
}

.reportdata-icon-btn--reset {
  background: #FFFFFF !important;
  border: 1px solid #D0D0D0 !important;
  color: #2C2C2C !important;
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.reportdata-icon-btn--reset:hover {
  background: #F5F5F5 !important;
  border-color: #C32E0E !important;
}

.reportdata-icon-btn--reset:hover .v-icon {
  color: #C32E0E !important;
}

.reportdata-download-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
  color: #ffffff;
  font-weight: 600;
  text-transform: none;
  border-radius: 16px;
  padding: 0 20px;
  letter-spacing: 0.4px;
}

.reportdata-download-btn:hover {
  background: linear-gradient(90deg, #fe6b3d 0%, #f3412f 100%);
}
</style>
